import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'error'];

  connect() {
    this.form = this.element.closest('form');

    if (this.form) {
      this.form.addEventListener('submit', this.validate);
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener('submit', this.validate);
    }
  }

  validate = (event) => {
    const hasChecked = this.checkboxTargets.some(checkbox => checkbox.checked);

    if (!hasChecked) {
      event.preventDefault();
      this.showError();
    } else {
      this.hideError();
    }
  };

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove('hidden');
      this.errorTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden');
    }
  }

  onChange() {
    const hasChecked = this.checkboxTargets.some(checkbox => checkbox.checked);

    if (hasChecked) {
      this.hideError();
    }
  }
}
